var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.832 3.33333C14.292 3.33333 14.6654 3.70667 14.6654 4.16667V7.66666L19.0095 4.625C19.1979 4.49333 19.4579 4.53917 19.5904 4.72833C19.6387 4.79833 19.6654 4.88167 19.6654 4.96667V15.0333C19.6654 15.2633 19.4787 15.45 19.2487 15.45C19.1629 15.45 19.0795 15.4233 19.0095 15.375L14.6654 12.3333V15.8333C14.6654 16.2933 14.292 16.6667 13.832 16.6667H2.16536C1.70536 16.6667 1.33203 16.2933 1.33203 15.8333V4.16667C1.33203 3.70667 1.70536 3.33333 2.16536 3.33333H13.832ZM12.9987 5H2.9987V15H12.9987V5ZM17.9987 7.3675L14.6654 9.70083V10.2992L17.9987 12.6325V7.3675Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.f4605c12.svg";
export { ForwardRef as ReactComponent };